<template>
  <div class="d-flex flex-column sticky-footer-wrapper">
    <app-header></app-header>
    <br />
    <router-view></router-view>

    <v-footer fixed padless>
    <v-col
    >
      {{ new Date().getFullYear() }} — <strong>Bolathedev</strong>
    </v-col>
  </v-footer>
  </div>
</template>

<script src="iziToast.min.js" type="text/javascript"></script> 
<script>
import { mapActions } from "vuex";
import Header from "./components/Header.vue";
export default {
  components: {
    appHeader: Header
  },
  data() {
    return {
      icons: ["mdi-home", "mdi-email", "mdi-calendar", "mdi-delete"],
      padless: true
    };
  },
  methods: {
    ...mapActions(["getShoppingCart", "listenToProductList"])
  },
  created() {
    let uid = this.$store.getters.currentUser.uid;
    this.listenToProductList();
    this.getShoppingCart({
      uid,
      currentCart: this.$store.getters.cartItemList
    });
  },
  computed: {
    localAttrs() {
      const attrs = {};

      if (this.variant === "default") {
        attrs.absolute = false;
        attrs.fixed = false;
      } else {
        attrs[this.variant] = true;
      }
      return attrs;
    }
  }
};
</script>

<style>
.foot {
  width: 100%;
}
#reset-store-panel {
  position: fixed;
  bottom: 0px;
  right: 0px;
}
body,
.sticky-footer-wrapper {
  min-height: 100vh;
}
.flex-fill {
  flex: 1 1 auto;
}
footer {
  height: 40px;
  color: #666;
  padding: 10px 0 10px 0;
  font-size: 85%;
}
footer a {
  color: #999;
}
footer a:hover {
  color: #efefef;
}
@media (max-width: 576px) {
  footer {
    height: 50px;
  }
}
</style>
